import React, { useState } from 'react';
import { WHATSAPP_URL } from '../../data/appData';

const QUICK_REPLIES = [
  'Su kaçağı var, acil yardım lazım!',
  'Gider tıkandı, ne yapmalıyım?',
  'Fiyat teklifi almak istiyorum',
  'Randevu almak istiyorum',
  'Çalışma saatleriniz nedir?',
];

export default function FloatingWhatsApp() {
  const [open, setOpen] = useState(false);

  const sendToWhatsApp = (msg) => {
    const text = encodeURIComponent(msg || 'Merhaba, tesisat konusunda yardım almak istiyorum.');
    window.open(`${WHATSAPP_URL}?text=${text}`, '_blank');
    setOpen(false);
  };

  return (
    <>
      {/* Chat Panel */}
      {open && (
        <div style={{
          position: 'fixed',
          bottom: '96px', right: '24px',
          width: '320px',
          background: 'var(--bg-card)',
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--border-color)',
          boxShadow: 'var(--shadow-lg)',
          zIndex: 999,
          overflow: 'hidden',
          animation: 'slideInUp 0.3s ease forwards',
        }}>
          {/* Header */}
          <div style={{
            background: 'linear-gradient(135deg, #25D366, #128C7E)',
            padding: '16px 20px',
            display: 'flex', alignItems: 'center', gap: '12px',
          }}>
            <div style={{
              width: '44px', height: '44px',
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '50%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '22px',
            }}>💧</div>
            <div>
              <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, color: 'white', fontSize: '0.95rem' }}>
                Taşgın Tesisat
              </div>
              <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.8)', display: 'flex', alignItems: 'center', gap: '5px' }}>
                <span style={{ width: '7px', height: '7px', background: '#8BC34A', borderRadius: '50%', display: 'inline-block' }}/>
                Çevrimiçi – Genellikle anında yanıtlar
              </div>
            </div>
          </div>

          {/* Chat bubble */}
          <div style={{ padding: '16px' }}>
            <div style={{
              background: 'var(--surface-1)',
              borderRadius: '0 12px 12px 12px',
              padding: '12px 16px',
              fontSize: '0.9rem', lineHeight: 1.5,
              color: 'var(--text-primary)',
              marginBottom: '4px',
            }}>
              👋 Merhaba! Ben Taşgın destek hattıyım. Size nasıl yardımcı olabilirim?
            </div>
            <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', paddingLeft: '4px' }}>Az önce</div>
          </div>

          {/* Quick replies */}
          <div style={{ padding: '0 16px 16px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginBottom: '4px', fontWeight: 600 }}>HIZLI YANIT SEÇ:</p>
            {QUICK_REPLIES.map(reply => (
              <button key={reply} onClick={() => sendToWhatsApp(reply)} style={{
                padding: '8px 14px',
                borderRadius: 'var(--radius-full)',
                background: 'transparent',
                border: '1.5px solid #25D366',
                color: '#25D366',
                fontSize: '0.82rem',
                fontWeight: 600,
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'all 0.2s',
              }}>
                {reply}
              </button>
            ))}
            <button onClick={() => sendToWhatsApp()} style={{
              marginTop: '4px',
              padding: '12px',
              borderRadius: 'var(--radius-md)',
              background: 'linear-gradient(135deg, #25D366, #128C7E)',
              border: 'none',
              color: 'white',
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: '0.9rem',
              cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
            }}>
              📱 WhatsApp'ta Sohbet Başlat
            </button>
          </div>
        </div>
      )}

      {/* Float button */}
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          position: 'fixed',
          bottom: '24px', right: '24px',
          width: '60px', height: '60px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #25D366, #128C7E)',
          border: 'none',
          cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '28px',
          boxShadow: '0 4px 20px rgba(37,211,102,0.5)',
          zIndex: 1000,
          transition: 'all var(--transition-spring)',
          transform: open ? 'scale(0.9)' : 'scale(1)',
        }}
      >
        {open ? '✕' : '💬'}
        {/* Pulse ring */}
        <span style={{
          position: 'absolute',
          inset: '-4px',
          borderRadius: '50%',
          border: '2px solid rgba(37,211,102,0.4)',
          animation: 'pulse-glow 2s ease-in-out infinite',
        }}/>
      </button>
    </>
  );
}
